<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="companies"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		companies: {
			query: gql`
				{
					companies(order_by: { company_name: asc }) {
						id
						company_name
						legal_name
						address
						phone
						email
						country {
							code
						}
						active
					}
				}
			`,
			update(data) {
				return data.companies.map(item => ({
					id: item.id,
					company_name: item.company_name,
					legal_name: item.legal_name,
					adress: item.address,
					phone: item.phone,
					email: item.email,
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: 'empresas',
			itemsTable: 'companies',
			itemsTitles: [
				'Id',
				'Nombre',
				'legal_name',
				'address',
				'Telefono',
				'Email'
			]
		}
	},
	components: { ListTable }
}
</script>
